import React from 'react';
import { Target, Users, Globe } from 'lucide-react';
import AboutHero from '../components/About/AboutHero';
import Background from '../components/About/Background';
import ValueCard from '../components/About/ValueCard';
import Approach from '../components/About/Approach';
import Activities from '../components/About/Activities';
import OurStrengths from '../components/About/OurStrengths';
import CallToAction from '../components/About/CallToAction';

const values = [
  { 
    icon: Target, 
    title: 'Our Mission', 
    description: 'To leverage capacity building in Climate Finance for sustainable development in Africa.' 
  },
  { 
    icon: Globe, 
    title: 'Our Vision', 
    description: 'To build impactful skills in Climate Finance on the African continent.' 
  },
  { 
    icon: Users, 
    title: 'Our Impact', 
    description: 'Supporting institutions across Africa, training future leaders in climate finance and sustainability.' 
  },
];

export default function About() {
  return (
    <div className="bg-white">
      <AboutHero />
      <Background />
      
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
            {values.map((value, index) => (
              <ValueCard key={value.title} {...value} />
            ))}
          </div>
        </div>
      </section>

      <Approach />
      <Activities />
      <OurStrengths />
      <CallToAction />
    </div>
  );
}